import { useCallback, useEffect, useState } from "react"
import { usePostHog } from "posthog-js/react"

type Survey = {
  id: string
  questions: { question: string }[]
}

export const usePosthogSurvey = () => {
  const [survey, setSurvey] = useState<Survey | null>(null)

  const posthog = usePostHog()

  useEffect(() => {
    posthog.getSurveys((surveys) => {
      if (surveys.length > 0) {
        const surveyToDisplay = surveys.find(
          (surveyItem) => surveyItem.conditions?.url === window.location.href,
        )

        setSurvey(surveyToDisplay ?? null)
      }
    }, true)
  }, [posthog])

  return { survey, posthog }
}

export const useResetPosthogUser = () => {
  const posthog = usePostHog()

  const resetPosthogUser = useCallback(() => {
    posthog.reset()
    // Some Feature flags depend on properties that are not instantly available.
    // If we want to make them available without waiting for server delays,
    // let's send these properties for flag evaluation.
    posthog.setPersonPropertiesForFlags({ $current_url: window.location.href })
    posthog.reloadFeatureFlags()
  }, [posthog])

  return resetPosthogUser
}
